import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../shared/shared.module';
import { AccountComponent } from './account.component';
import { ForgotComponent } from './forgot/forgot.component';
import { LoginComponent } from './login/login.component';
import { ResetComponent } from './reset/reset.component';
import { SignUpComponent } from './signup/signup.component';
import { NgxMaskModule } from 'ngx-mask';
import { STEPPER_GLOBAL_OPTIONS } from '@angular/cdk/stepper';

@NgModule({
    declarations: [
        AccountComponent,
        LoginComponent,
        SignUpComponent,
        ForgotComponent,
        ResetComponent
    ],
    imports: [
        CommonModule,
        SharedModule,
        NgxMaskModule.forRoot(),
        RouterModule.forChild([
            {
                path: '',
                component: AccountComponent,
                children: [
                    {
                        path: 'login',
                        component: LoginComponent
                    },
                    {
                        path: 'forgot',
                        component: ForgotComponent
                    },
                    {
                        path: 'reset',
                        component: ResetComponent
                    },
                    {
                        path: 'signup',
                        component: SignUpComponent
                    }
                ]
            }
        ])
    ],
    providers: [
        {
          provide: STEPPER_GLOBAL_OPTIONS,
          useValue: { displayDefaultIndicatorType: false }
        }
    ]
})
export class AccountModule {}
